import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import Header from "../PackageInfo/Header";
import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";

import sav1 from "../../Images/SavlyaGhat/sav1.jpg";
import sav2 from "../../Images/SavlyaGhat/sav2.jpg";
import sav3 from "../../Images/SavlyaGhat/sav3.jpg";
import sav4 from "../../Images/SavlyaGhat/sav4.jpg";
import sav5 from "../../Images/SavlyaGhat/sav5.jpg";

const data = [
  {
    day: "Day 1",
    subheading: "Savlya Ghat Trek",
    schedule: [
      { time: "05:45 AM", activity: "Pick-up at Hadapsar." },
      { time: "06:05 AM", activity: "Pick-up at Swargate." },
      { time: "06:25 AM", activity: "Pick-up at Vanaj Metro Station." },
      { time: "06:40 AM", activity: "Pick-up at Wakad Bridge." },
      { time: "07:05 AM", activity: "Pick-up at Hinjwadi." },
      {
        time: "08:30 AM",
        activity: "Breakfast in route.",
      },
      {
        time: "10:30 AM",
        activity: "Reach base village and enjoy trek briefing.",
      },
      {
        time: "10:45 AM",
        activity: "Begin the scenic Savlya Ghat Trek.",
      },
      {
        time: "11:45 AM",
        activity:
          "Reach the main viewpoint and enjoy panoramic views of the Sahyadri ranges.",
      },
      {
        time: "01:30 PM",
        activity: "Begin the return trek towards the base village.",
      },
      {
        time: "02:30 PM",
        activity:
          "Reach base village and Start the journey to enjoy Veg & Non-Veg Lunch.",
      },
      {
        time: "04:00 PM",
        activity: "Start the return journey to Pune.",
      },
      {
        time: "05:00 PM",
        activity: "Tea break in route.",
      },
      {
        time: "09:00 PM",
        activity: "Approx. arrival back in Pune.",
      },
    ],
    meals: ["Breakfast", "Lunch", "Tea"],
    notes: [
      "Savlya Ghat is one of the most beautiful hidden monsoon trails near Tamhini and is best experienced during the rainy season.",
    ],
    inclusions: [
      "🚌 Pune to Pune Travel by Non-AC Bus",
      "🍽️ Breakfast & Morning Tea",
      "🥘 Delicious Veg & Non-Veg Lunch",
      "☕ Evening Tea",
      "🧭 Experienced Trek Leader & Local Guide",
      "🩺 Basic First Aid & Hydration Support",
      "🏞️ Entry & Local Charges",
    ],
    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Personal snacks, cold drinks, and extra food expenses.",
      "Personal insurance or medical expenses.",
      "Any emergency evacuation charges.",
      "Photography or videography permits (if applicable).",
    ],
    verticalCards: [
      { title: "Savlya Ghat Trail", image: sav1 },
      { title: "Monsoon Waterfalls", image: sav2 },
      { title: "Dense Forest", image: sav3 },
      { title: "Valley Viewpoint", image: sav4 },
      { title: "Sahyadri Landscapes", image: sav5 },
    ],
    trekData: [
      {
        name: "Savlya Ghat",
        image: sav1,
        info: "Explore the hidden beauty of the Sahyadris with the Savlya Ghat Trek near Tamhini Ghat. 🌿⛰️ This scenic monsoon trek follows an ancient ghat route once used by locals to connect villages across the Western Ghats. The trail passes through dense forests, flowing streams, mist-covered valleys, and seasonal waterfalls, offering a perfect blend of adventure and natural beauty. Ideal for beginners and nature lovers, Savlya Ghat rewards trekkers with breathtaking panoramic views and an offbeat trekking experience away from crowded trails. It is one of the best monsoon treks near Pune for those seeking lush greenery, peaceful landscapes, and an authentic Sahyadri adventure.",
      },
    ],
    faq: [
      {
        question: "What is Savlya Ghat Trek known for?",
        answer:
          "Savlya Ghat is known for its ancient trekking route, dense forests, seasonal waterfalls, scenic valley viewpoints, and lush monsoon landscapes.",
      },
      {
        question: "Is Savlya Ghat Trek suitable for beginners?",
        answer:
          "Yes. The trek is beginner-friendly to moderate and can be comfortably completed by anyone with basic fitness.",
      },
      {
        question: "What is the difficulty level of Savlya Ghat Trek?",
        answer:
          "The trek is generally considered easy to moderate. Some sections can become slippery during monsoon and require proper trekking shoes.",
      },
      {
        question: "What should I carry for the trek?",
        answer:
          "Carry a small backpack, water bottle, rainwear, trekking shoes with good grip, extra clothes, and personal medicines. For a complete list, please check our Things to Carry section.",
      },
      {
        question: "Are meals included?",
        answer:
          "Yes. Breakfast, morning tea, lunch, and evening tea are included in the package.",
      },
      {
        question: "Is transportation included?",
        answer:
          "Yes, Pune to Pune travel by Non-AC bus is included in the package.",
      },
      {
        question: "Will we see waterfalls during the trek?",
        answer:
          "Yes. During monsoon, the trail features several seasonal waterfalls, streams, and beautiful water crossings.",
      },
      {
        question: "Will there be a trek leader and guide?",
        answer:
          "Yes. Experienced trek leaders and local guides will accompany the group throughout the trek.",
      },
      {
        question: "Why should I choose Savlya Ghat Trek?",
        answer:
          "Savlya Ghat offers a less crowded trekking experience with beautiful waterfalls, dense forests, historic trails, and spectacular Sahyadri views, making it one of the best hidden monsoon treks near Pune.",
      },
    ],
  },
];

const SavlyaGhat = () => {
  return (
    <div className="bg-gray-50 ">
      {" "}
      <Header trekData={data[0].trekData[0]} />{" "}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {" "}
        <TrekBasicInfo
          trekName="Savlya Ghat"
          location="Tamhini Ghat"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />{" "}
        <PackageInclusions />{" "}
      </div>
      ```
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default SavlyaGhat;
